interface AccoladeItem {
  title: string;
  project?: string;
}

interface AccoladeGroup {
  id: string;
  organization: string;
  badge: string;
  isPrestigous: boolean;
  categories: string[];
  items: AccoladeItem[];
}

const ACCOLADES_DATA: AccoladeGroup[] = [
  {
    id: 'cannes',
    organization: 'Cannes Lions',
    badge: 'Lions Bronze',
    isPrestigous: true,
    categories: ['international', 'gold-tier'],
    items: [
      { title: 'Lions Bronze' },
      { title: '360 Brand & Identity Experience' },
      { title: 'Craft, Illustration & Graphic Design' },
      { title: 'Kinetic v5' }
    ]
  },
  {
    id: 'crowbar',
    organization: 'The Crowbar Awards',
    badge: 'Interactive Jury',
    isPrestigous: false,
    categories: ['jury'],
    items: [
      { title: 'Jury for the interactive category' }
    ]
  },
  {
    id: 'fwa',
    organization: 'The FWA',
    badge: '7x Winner',
    isPrestigous: true,
    categories: ['international', 'gold-tier'],
    items: [
      { title: 'Asocial', project: 'Mobile of The Day' },
      { title: 'Makisan', project: 'The Cutting Edge Project of the week' },
      { title: 'Asocial', project: 'Mobile of The Day' },
      { title: 'Makisan', project: 'Site of The Day (SOTD)' },
      { title: 'Hello Mankind', project: 'Site of The Day (SOTD)' },
      { title: 'Kinetic v5', project: 'Mobile of The Day' },
      { title: 'Kinetic v5', project: 'Site of The Day (SOTD)' }
    ]
  },
  {
    id: 'oneshow',
    organization: 'The One Club',
    badge: 'Interactive Winner',
    isPrestigous: true,
    categories: ['international'],
    items: [
      { title: 'One Show Interactive', project: 'Kinetic v5' }
    ]
  },
  {
    id: 'webby',
    organization: 'Webby Awards',
    badge: 'Winner / Nominee',
    isPrestigous: true,
    categories: ['international', 'gold-tier'],
    items: [
      { title: 'Best Visual Design' },
      { title: 'Kinetic v5' }
    ]
  },
  {
    id: 'cca',
    organization: 'Creative Circle',
    badge: 'Multiple Awards',
    isPrestigous: false,
    categories: ['local-regional'],
    items: [
      { title: 'Spatial Design', project: 'Nike Disruptive Retail' },
      { title: 'Interactive Tools', project: 'Nike Disruptive Retail' },
      { title: 'Websites & Microsites', project: 'Kinetic v5' }
    ]
  },
  {
    id: 'spikes',
    organization: 'Spikes Asia',
    badge: 'Digital Bronze',
    isPrestigous: false,
    categories: ['local-regional'],
    items: [
      { title: 'Digital Bronze', project: "Chuck's Cup 2010" }
    ]
  }
];

function Accolades() {
  return (
    <div>
      <h2 className="section-title">Accolades</h2>

      {/* Flat Index Listing */}
      <div className="accolades-list">
        {ACCOLADES_DATA.map(group => (
          <section key={group.id} className="accolade-section">
            <div className="accolade-row">
              {/* Left Column: Organization details */}
              <div className="accolade-meta-col">
                <span className="accolade-org-name">{group.organization}</span>
                <span className="accolade-badge-text">{group.badge}</span>
              </div>

              {/* Right Column: Specific awards */}
              <ul className="accolades-items-list">
                {group.items.map((item, idx) => (
                  <li key={idx} className="accolade-item-row">
                    <span className="accolade-item-title">{item.title}</span>
                    {item.project && (
                      <span className="accolade-item-detail">{item.project}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default Accolades;
